<template>
    <div v-if="image" class="spouse-wrap">
        <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_spouse.png" />
        <div class="spouse">
            <img :src="image" />
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                images: {
                    '20-15': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_15m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_15f.png',
                    },
                    '30-8': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_23m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_23f.png',
                    },
                    '30-16': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_31m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_31f.png',
                    },
                    '40-3': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_35m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/spouse_35f.png',
                    },
                },
                image: ''
            }
        },

        watch: {
            '$userData.age': {
                handler(val) {
                    if (this.image) {
                        $('.spouse')
                            .css('transition', '')
                            .css('-webkit-transition', '')
                            .css('transform', '')
                            .css('-webkit-transform', '')
                            .css('opacity', 1)
                        this.image = ''
                    }
                }
            },
        },

        computed: {
            age() {
                return this.$userData.age
            }
        },

        beforeDestroy() {
            this.$eventBus.$off('SHOW_SPOUSE')
            this.$eventBus.$off('MOVE_SPOUSE')
        },

        mounted() {
            const self = this
            this.$eventBus.$on('SHOW_SPOUSE', question => {
                if (!self.images[`${this.age}-${question.sequence}`]) return
                self.image = self.images[`${this.age}-${question.sequence}`][this.$userData.gender.toLowerCase()]

                setTimeout(_ => {
                    $('.spouse-wrap').fadeIn('slow')
                    $('.spouse').css('visibility', 'visible')
                })
            })

            this.$eventBus.$on('MOVE_SPOUSE', (amount, interval) => {
                if (!self.image) return

                const sec = interval / 1000

                $('.spouse-wrap').fadeOut('slow')

                $('.spouse')
                    .css('transition', `transform ${sec}s linear`)
                    .css('-webkit-transition', `-webkit-transform ${sec}s linear`)
                    .css('transform', `translateX(${amount}px)`)
                    .css('-webkit-transform', `translateX(${amount}px)`)
                    .animate({
                        opacity: 0
                    }, interval, _ => {
                        $('.spouse')
                            .css('visibility', 'hidden')
                            .css('transition', '')
                            .css('-webkit-transition', '')
                            .css('transform', '')
                            .css('-webkit-transform', '')
                            .css('opacity', 1)
                        self.image = ''
                    })
            })
        }
    }
</script>

<style lang="scss" scoped>
    .spouse-wrap {
        position: absolute;
        top: 0; bottom: 0;
        left: 0; right: 0;
        display: none;

        .spouse {

            position: absolute;
            bottom: 65px;
            right: 605px;
            visibility: hidden;

            img {
                height: 128px;
            }
        }
    }

</style>
